let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7In40")).then(() => parcelRequire('1g9AV'));